'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 12px !important;\n  cursor: pointer;\n  margin-left: 10px;\n  color: ', ';\n  transform: translateY(1px);\n'], ['\n  font-size: 12px !important;\n  cursor: pointer;\n  margin-left: 10px;\n  color: ', ';\n  transform: translateY(1px);\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: ', ';\n  line-height: ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 3px;\n  white-space: nowrap;\n  padding: 0px 10px;\n  margin: 3px 0 0 3px;\n  user-select: none;\n  ', ';\n'], ['\n  height: ', ';\n  line-height: ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 3px;\n  white-space: nowrap;\n  padding: 0px 10px;\n  margin: 3px 0 0 3px;\n  user-select: none;\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var sizes = function sizes(size) {
  switch (size) {
    case 'small':
      return 14;

    case 'normal':
      return 22;

    case 'large':
      return 30;

    default:
      return 22;
  }
};

var CloseIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, function (_ref) {
  var selected = _ref.selected;
  return selected ? _colors.white : _colors.darkGrey;
});

var StyledValue = _styledComponents2.default.div(_templateObject2, function (_ref2) {
  var size = _ref2.size;
  return sizes(size) + 'px';
}, function (_ref3) {
  var size = _ref3.size;
  return sizes(size) + 'px';
}, function (_ref4) {
  var selected = _ref4.selected;
  return selected ? _colors.red : _colors.grey;
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected ? _colors.white : _colors.black;
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && 'pointer-events: none;';
});

var SelectValue = function SelectValue(_ref7) {
  var children = _ref7.children,
      disabled = _ref7.disabled,
      selected = _ref7.selected,
      deletable = _ref7.deletable,
      onClick = _ref7.onClick,
      size = _ref7.size;
  return _react2.default.createElement(StyledValue, {
    disabled: disabled,
    selected: selected,
    size: size
  }, children, ' ', deletable && _react2.default.createElement(CloseIcon, {
    icon: 'close',
    selected: selected,
    onClick: onClick
  }));
};

SelectValue.propTypes = {
  children: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  selected: _propTypes2.default.bool,
  deletable: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  size: _propTypes2.default.string
};
SelectValue.defaultProps = {
  disabled: false,
  selected: false,
  deletable: false
};
exports.default = SelectValue;